import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

export interface ChapterPositionMap {
  id: string;
  position: number;
}

export type ActiveTreeId = string | TreeStates;

export enum TreeStates {
  First = 'first',
  Last = 'last',
}

@Injectable()
export class TreeScrollService {
  private chaptersOnCurrentPage = new Subject<ChapterPositionMap[]>();
  private chapterMap: ChapterPositionMap[];
  public activeTreeElementId = new Subject<ActiveTreeId>();
  public chaptersReorderedEvent = new Subject<void>();
  public showChaptersTree = new BehaviorSubject<boolean>(false);

  static readonly AppHeaderHeight = 64;
  latestScroll = -TreeScrollService.AppHeaderHeight;
  private appHeaderHeight = TreeScrollService.AppHeaderHeight;

  constructor() {
    this.chaptersOnCurrentPage.subscribe((newMap) => {
      this.chapterMap = newMap;
    });
  }

  public captureScrollEvent(event: Event) {
    const scrollTop = (event.target as HTMLElement).scrollTop;
    this.latestScroll = scrollTop - this.appHeaderHeight;
    const scrollHeight = (event.target as HTMLElement).scrollHeight;
    const clientHeight = (event.target as HTMLElement).clientHeight;
    let minChapterPosition = 0;
    let id = '';
    if (!this.chapterMap || this.chapterMap.length === 0) {
      this.activeTreeElementId.next(TreeStates.First);
    } else if (Math.ceil(scrollTop) + clientHeight >= scrollHeight) {
      this.activeTreeElementId.next(TreeStates.Last);
    } else {
      this.chapterMap.forEach((chapter) => {
        if (this.isChapterVisible(chapter, minChapterPosition, scrollTop)) {
          minChapterPosition = chapter.position;
          id = chapter.id;
        }
      });
      if (!minChapterPosition && !id) {
        minChapterPosition = this.chapterMap[0].position;
        id = this.chapterMap[0].id;
      }
      this.activeTreeElementId.next(id);
    }
  }

  private isChapterVisible(chapter: ChapterPositionMap, minChapterPosition: number, scrollTop: number): boolean {
    return (
      scrollTop + 3 * this.appHeaderHeight >= Math.floor(chapter.position) && Math.floor(chapter.position) > Math.floor(minChapterPosition)
    );
  }

  public updateScrollOnChanges(): void {
    const chapters = Array.from(document.querySelectorAll<HTMLElement>('[widget-type="chapter"]'));
    const scroll = this.latestScroll;

    const chapterMap = chapters
      .map((chapter) => {
        const id = chapter.getAttribute('data-uniqueid');
        if (!id) return null;

        return {
          id,
          position: chapter.getBoundingClientRect().y + scroll,
        };
      })
      .filter((item) => !!item);

    this.chaptersOnCurrentPage.next(chapterMap);
  }
}
